// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'

function SidebarCTABox ({ children, className }) {
  return (
    <div className={`sidebar-cta-box ${className}`}>
      <div className='sidebar-cta-box-content'>
        {children}
      </div>
    </div>
  )
}

function SidebarCTABoxHeader ({ children }) {
  return (
    <div className='sidebar-cta-box-header pro-head-6'>
      {children}
    </div>
  )
}

function SidebarCTABoxBody ({ children }) {
  return (
    <div className='sidebar-cta-box-body pro-text-s'>
      {children}
    </div>
  )
}

function SidebarCTABoxLink ({ href, text }) {
  return (
    <div className='sidebar-cta-box-link'>
      <a href={href} target='_blank' rel='noreferrer'>
        <span className='sidebar-cta-box-link-text pro-text-s pro-bold'>
          {text}
        </span>
        <i className='fas fa-arrow-right pro-text-xs' />
      </a>
    </div>
  )
}

SidebarCTABox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

SidebarCTABox.defaultProps = {
  children: null,
  className: ''
}

SidebarCTABoxHeader.propTypes = {
  children: PropTypes.node
}

SidebarCTABoxHeader.defaultProps = {
  children: null
}

SidebarCTABoxBody.propTypes = {
  children: PropTypes.node
}

SidebarCTABoxBody.defaultProps = {
  children: null
}

SidebarCTABoxLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string
}

SidebarCTABoxLink.defaultProps = {
  href: null,
  text: null
}

export { SidebarCTABox, SidebarCTABoxHeader, SidebarCTABoxBody, SidebarCTABoxLink }
